<template>
  <div class="container">
    <div class="overView">
      <div class="data" v-if="$store.state.user.userInfo.natureId == 2">
        <div class="dataList1">
          <div class="contents">
            <div class="top flex">
              <p>火警</p>
              <router-link
                :to="{
                  name: '/report-detail',
                  path: '/report/report-details',
                  query: { id: this.cpNum, name: this.companyName, type: 3 },
                }"
                tag="span"
              >
                <el-button
                  round
                  style="font-size: .75rem !important; margin-left: .4375rem;"
                  class="elButton"
                  size="mini"
                  >查看详情</el-button
                >
              </router-link>
            </div>
            <div>
              最近7天报警总数
              <div class="flex mt5">
                <div class="botoom " :title="alarmOverviewList.fireCount || 0">
                  {{ alarmOverviewList.fireCount || 0 }}
                </div>
                <el-button
                  round
                  style="font-size: .75rem !important; margin: .3125rem;"
                  class="elButton"
                  size="mini"
                  @click="showMoreList = true"
                  >火警记录</el-button
                >
              </div>
            </div>
          </div>
          <div
            class="fireArem cursor"
            :class="[isWaring ? 'firewaring' : 'fireArem']"
            @click="$store.commit('SHOWBJlIST', true)"
          >
            <div class="img1"></div>
            <div class="fire-botton center">报警</div>
          </div>
        </div>
        <div class="dataList1">
          <div class="contents">
            <div class="top flex">
              <p>电气监控</p>
              <router-link
                :to="{
                  name: '/electronic-detail',
                  path: 'report/electronic-detaill',
                  query: { id: this.cpNum, name: this.companyName, type: 7 },
                }"
                tag="span"
              >
                <el-button
                  round
                  style="font-size: .75rem !important; margin-left: .4375rem;"
                  class="elButton"
                  size="mini"
                  >查看详情</el-button
                >
              </router-link>
            </div>
          </div>
          <div class="top">最近七天数据统计</div>
          <div class="top"><div class="img2"></div></div>
          <div class="botoom" :title="alarmOverviewList.electricalCount || 0">
            {{ alarmOverviewList.electricalCount || 0 }}
          </div>
        </div>
        <div class="dataList1">
          <div class="top flex">
            <p>巡查</p>
            <router-link
              :to="{
                name: '/safe/safe-statistics',
                path: '/safe/safe-statistics',
                query: { c_num: this.cpNum, name: this.companyName, type: 8 },
              }"
              tag="span"
            >
              <el-button
                round
                style="font-size: .75rem !important; margin-left: .4375rem;"
                class="elButton"
                size="mini"
                >查看详情</el-button
              >
            </router-link>
          </div>
          <div class="top">隐患处理数</div>
          <div class="top"><div class="img3"></div></div>
          <div
            class="botoom"
            :title="alarmOverviewList.hiddenDangersCount || 0"
          >
            {{ alarmOverviewList.hiddenDangersCount || 0 }}
          </div>
        </div>
        <el-dialog
          title="处理任务"
          :visible.sync="showCL"
          :close-on-click-modal="false"
          :append-to-body="true"
          :modal-append-to-body="true"
          v-if="showCL"
          width="50%"
        >
          <div v-loading="leftfiretopLoading">
            <el-form ref="form" v-model="clForm" label-width="110px">
              <el-form-item prop="tr_name" label="单位名称:">
                {{ clForm.company }}
              </el-form-item>
              <el-form-item prop="tr_name" label="设备名称:"> </el-form-item>
              <el-form-item prop="tr_name" label="设备型号:">
                {{ clForm.address }}
              </el-form-item>
              <el-form-item prop="tr_sign_time" label="报警时间:">
                {{ clForm.nowtime }}
              </el-form-item>
              <el-form-item prop="tr_name" label="报警类型:">
                {{ clForm.evenClass }}
              </el-form-item>

              <el-form-item label="报警地点:">
                {{ clForm.msgDescribe }}
              </el-form-item>
              <el-form-item label="报警设备:">
                {{ clForm.deviceType }}
              </el-form-item>

              <el-form-item label="报警点位:">
                {{ clForm.detailAddr }}
              </el-form-item>
              <el-form-item label="处理单号:">
                {{ clForm.id }}
              </el-form-item>
              <!-- <el-form-item prop="tr_name" label="处理时间:">
          {{ clForm.dispose_time }}
        </el-form-item> -->
              <el-form-item label="处理人员:">
                {{ $local.get("userInfo").username }}
              </el-form-item>
              <el-form-item label="处理内容:">
                <el-input type="textarea" v-model="clForm.context"></el-input>
              </el-form-item>
              <el-form-item label="是否误报:">
                <el-checkbox v-model="clForm.wubao">误报</el-checkbox>
              </el-form-item>
            </el-form>
            <div class="center" v-if="clForm.dosomthing == 0">
              <el-button type="primary" @click="handleById()" size="small"
                >确定</el-button
              >
              <el-button @click="showCL = false" size="small">取消</el-button>
            </div>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="showMoreList"
          width="100%"
          @close="close"
          :show-close="false"
          :append-to-body="true"
          class="dialog_list"
        >
          <div slot="title" class="dialog-header">
            <div class="d-title flex1" style="position: relative">
              <i
                class="icon-tr-Real-time-alarm"
                style="padding-right: .3125rem"
              ></i>
              <span style="color: white">历史报警信息</span>
            </div>
            <div class="d-right align-center">
              <span
                class="icon-tr-Close cursor"
                @click="showMoreList = false"
              ></span>
            </div>
          </div>
          <div
            style="overflow: auto; height: 18.75rem;"
            v-loading="moreLoad"
            class="form-item"
          >
            <div class="ml20 flex searchform">
              <fm-generate-form
                :data="histsearch"
                ref="histsearch"
              ></fm-generate-form>
              <div style="inline" class="ml10 el-form-last">
                <div v-if="histAll" style="width: 17.5rem;margin-left:.625rem;">
                  <span>单位名称:</span>
                  <el-input
                    class="ml10"
                    style="width: 60%"
                    size="small"
                    v-model="listParams.company"
                  >
                  </el-input>
                </div>
                <span class="last-form" style="width:5rem;">报警类型:</span>
                <el-select
                  v-model="listParams.evenClass"
                  size="small"
                  class="ml10 last-form"
                >
                  <el-option
                    v-for="item in Object.values(this.$map.bjStatus)"
                    :key="item"
                    :value="item"
                    >{{ item }}</el-option
                  >
                </el-select>
              </div>
              <div class="last-btn" style="width: 15rem;">
                <el-button type="primary ml20" @click="searchsub" size="small"
                  >查询</el-button
                >
                <el-button type=" ml20" @click="resetSearch" size="small"
                  >查看全部</el-button
                >
              </div>
            </div>
            <table class="hj-message-table" style="width: 100%">
              <thead>
                <tr>
                  <th style="width: 15%">单位名称</th>
                  <th style="width: 15%">报警时间</th>
                  <th style="width: 15%">处理时间</th>
                  <th style="width: 5%">报警类型</th>
                  <th style="width: 14%">联系电话</th>
                  <th style="width: 8%">设备类型</th>
                  <th style="width: 15%">报警节点</th>
                  <th style="width: 10%">报警地点</th>
                  <th style="width: 10%">操作</th>
                </tr>
              </thead>
              <tbody class="tr_context_box">
                <tr
                  v-for="(item, index) in companyInfo"
                  :key="index"
                  v-if="item.company"
                  :class="
                    (item.isLate > 20 || !item.dispose_time) &&
                    signaltype.indexOf(item.evenClass) > -1
                      ? 'mark'
                      : ''
                  "
                >
                  <td>{{ item.company }}</td>
                  <td>{{ item.nowtime }}</td>
                  <td :title="item.dispose_time">{{ item.dispose_time }}</td>
                  <td>{{ item.evenClass }}</td>
                  <td>{{ item.phone }}</td>
                  <td :title="item.deviceType">{{ item.deviceType }}</td>
                  <td :title="item.context">{{ item.detailAddr }}</td>
                  <td :title="item.msgDescribe">{{ item.msgDescribe }}</td>
                  <td>
                    <a
                      title="查看点位"
                      class="cursor"
                      @click="openPoint(item)"
                      style="color: #4a9dff"
                      >查看点位</a
                    >
                    <a
                      v-if="item.dosomthing == 0"
                      title="点击处理"
                      class="cursor ml10"
                      @click="CLdatail(index)"
                      style="color: #4a9dff"
                      >处理</a
                    >
                    <span v-else @click="CLdatail(index)" class="ml10"
                      >已处理</span
                    >
                  </td>
                </tr>
              </tbody>
              <el-pagination
                background
                v-if="companyInfoCount > 10"
                layout="prev, pager, next"
                :page-size="listParams.limit || 10"
                @current-change="pageChange"
                :current-page.sync="listParams.page"
                :total="companyInfoCount"
              >
              </el-pagination>
            </table>

            <p class="mt20 tx-center" v-show="companyInfo.length == 0">
              没有更多
            </p>
          </div>
        </el-dialog>
        <el-dialog title="标定" :visible.sync="showBD" width="600PX">
          <div>
            <fm-generate-form
              :data="searchForm"
              :value="editData"
              ref="searchForm"
            ></fm-generate-form>
          </div>
          <span slot="footer" class="dialog-footer center">
            <el-button @click="showBD = false">取 消</el-button>
            <el-button type="primary" @click="saveBD">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
          title="单位详情"
          style="min-height: 31.25rem"
          :visible.sync="showmod"
          width="100%"
        >
          <company :c_num="unitInfo.c_company_num" />
        </el-dialog>

        <el-dialog
          title="查看点位信息"
          width="80%"
          style="height:95%"
          :modal-append-to-body="false"
          :append-to-body="true"
          :visible.sync="crtpoint"
          custom-class="crtVideoDia"
        >
          <crtmark
            :compnum="crtcompany"
            :companyNum="cpNum"
            ref="crtmark"
            :nowtime="companyInfoCount.nowtime"
          ></crtmark>
        </el-dialog>
      </div>

      <!-- natureId不为 2显示的样式-->
      <div class="data" v-else>
        <div class="dataList">
          <div class="top">
            <p>火警</p>
            <router-link
              :to="{
                name: '/report-detail',
                path: '/report/report-details',
                query: { id: this.cpNum, name: this.companyName, type: 3 },
              }"
              tag="span"
            >
              <el-button
                round
                style="font-size: .75rem !important; margin-left: .4375rem;"
                class="elButton"
                size="mini"
                >查看详情</el-button
              >
            </router-link>
          </div>
          <div class="top">最近七天报警总数</div>
          <div class="top"><div class="img1"></div></div>
          <div class="botoom" :title="alarmOverviewList.fireCount || 0">
            {{ alarmOverviewList.fireCount || 0 }}
          </div>
        </div>

        <div class="dataList">
          <div class="top">
            <p>电气监控</p>
            <router-link
              :to="{
                name: '/electronic-detail',
                path: 'report/electronic-detaill',
                query: { id: this.cpNum, name: this.companyName, type: 7 },
              }"
              tag="span"
            >
              <el-button
                round
                style="font-size: .75rem !important; margin-left: .4375rem;"
                class="elButton"
                size="mini"
                >查看详情</el-button
              >
            </router-link>
          </div>
          <div class="top">最近七天数据统计</div>
          <div class="top"><div class="img2"></div></div>
          <div class="botoom" :title="alarmOverviewList.electricalCount || 0">
            {{ alarmOverviewList.electricalCount || 0 }}
          </div>
        </div>

        <div class="dataList">
          <div class="top">
            <p>巡查</p>
            <router-link
              :to="{
                name: '/safe/safe-statistics',
                path: '/safe/safe-statistics',
                query: { c_num: this.cpNum, name: this.companyName, type: 8 },
              }"
              tag="span"
            >
              <el-button
                round
                style="font-size: .75rem !important; margin-left: .4375rem;"
                class="elButton"
                size="mini"
                >查看详情</el-button
              >
            </router-link>
          </div>
          <div class="top">隐患处理数</div>
          <div class="top"><div class="img3"></div></div>
          <div
            class="botoom"
            :title="alarmOverviewList.hiddenDangersCount || 0"
          >
            {{ alarmOverviewList.hiddenDangersCount || 0 }}
          </div>
        </div>
      </div>

      
    </div>
  </div>
</template>
<script>
import company from "@/components/company.vue";
import crtmark from "@/components/crtpoints.vue";
import { getHjMsg, handleById } from "@/api/home";
import { mapState } from "vuex";
import { alarmOverview, deviceCountGroupType } from "@/api/report.js";

export default {
  components: { crtmark,company},
  computed: {
    ...mapState([
      "isMute",
      "isWaring",
      "bjList",
      "bimStaus",
      "bimUrl",
      "showmoredia",
      "isLoop",
      "showFire",
      "alarmDtItem",
    ]),
  },
  props: ["cpNum"],
  data() {
    return {
      pieDataChart: {}, // 评估echarts
      MaintenanceChart: {}, // 维保echarts
      InspectionChart: {}, // 消检echarts
      electricalInspectionChart: {}, // 电检echarts
      pieData: [], // 评估数据
      Maintenance: [], // 维保数据
      Inspection: [], // 消检数据
      electricalInspection: [], // 电检数据
      activeVar: 0,
      changeList: [
        { code: 1, title: "评估" },
        { code: 2, title: "维保" },
        { code: 5, title: "消检" },
        { code: 8, title: "电检" },
      ],
      alarmOverviewList: [],
      deviceCountGroupTypeList: [],
      disabled: false,
      companyName: this.$local.get("company")?.c_name, // 获取单位名称
      portList: [],

      loading: true,
      electricalCount: "",
      fireCount: "",
      hiddenDangersCount: "",
      checkAll: false,
      searchForm: this.$getForm("bdform"),
      c_portList: [], // 上方服务类型
      options: [], // 省市区
      selectedArea: "",
      selectServiceType: [],
      companyInfomation: {},
      histsearch: this.$getForm("historysearch"),
      noPolice: this.$store.state.noPolice || [],
      editData: {},
      signaltype: ["火警", "手动报警", "超限", "漏电"],
      showstatic: false,
      leftfiretopLoading: false,
      moreLoad: false,
      rightLoading: false, // 右侧单位信息
      showBD: false,
      showmod: false, //单位信息
      uploadmod: false, // 上传信息
      deviceload: false,
      crtpoint: false, // crt点位信息
      company: "",
      crtcompany: {},
      companyInfoCount: 0,

      rightPointLoading: false,
      hasPoint: true,
      showCL: false,
      histAll: false, // 是否查询全部历史
      companyInfoIndex: 0,
      showMoreMsg: false,
      showMoreList: false,
      MsgList: [],
      CLIndex: 0,

      companyInfo: [],
      // 上传火警表单
      upform: {
        remark: "",
        nowtime: "",
        sc_user: this.$store.state.userInfo.username,
        DType: 199,
      },
      // 所有单位筛选查询

      leftFindParams: {
        areaList: [],
        cportList: [],
        supervisionLevel: "",
      },
      // 首页上方单位数量筛选
      topCompanyCount: {},
      clForm: {
        context: "",
        wubao: false,
      },
      msgLoading: false,
      unit: "network",
      comnyInfo: "",
      msgParams: {
        page: 1,
        limit: 10,
        dosomthing: "",
        maxPage: 2,
        evenClass: "火警",
      },
      listParams: {
        page: 1,
        limit: 10,
        evenClass: "火警",
        company: "",
        c_company_num: "",
        maxPage: 2,
        type: "火警",
        starttime: "",
        endtime: "",
      },
      evenClass: "fire",

      unitInfo: {},

      unitbjList: [],
      unitbjList1: [],
      todayBj: [],
      dateArray: [],
      BDform: {},
      onlineList: [],
      leaveList: [],
      isShow: false,
    };
  },

  watch: {
    // 单位名称 请求接口
    cpNum() {
      this.getAlarmOverview();
      this.getDeviceCountGroupType();

      this.$get(`/trxf/main/xf/companyInfo/getCPort/${this.cpNum}`).then(
        (res) => {
          console.log(res);
          if (res.data == null || res.data.length == 0) {
            this.clearEchar();
            this.activeVar = 3;
          }
          if (res.data) {
            this.isShow = true;
            // log(res, "this.portList");
            this.portList = res.data;
            let active = null;
            this.changeList = this.changeList.map((item, index) => {
              item.disabled = true;

              if (res.data.filter((it) => it.code == item.code).length) {
                if (active === null) {
                  active = {
                    index,
                    title: item.name,
                  };
                }
                item.disabled = false;
              }
              return item;
            });
            this.chooseType(active.title, active.index);
          } else {
            this.isShow = false;
            return;
          }
        }
      );
    },
    showCL(val) {
      if (!val) {
        this.$store.commit("DETAILALRAM", null);
      }
    },
    crtpoint(val) {
      if (!val) {
        this.$refs["crtmark"]?.reset();
      }
    },
    alarmDtItem(val) {
      if (val && val.c_company_num) {
        this.CLdatail(null, val);
      }
    },
    showFire(val) {
      this.showMoreList = val;
    },
    showMoreList(val) {
      if (!val) {
        this.histAll = false;
        this.getHistAll(this.listParams);
        this.listParams.starttime = "";
        this.listParams.endtime = "";
        this.companyInfo = [];
        this.listParams.evenClass = "火警";
        this.listParams.company = "";
      }
    },
    showMoreMsg(val) {
      if (val) {
        this.getHjMsg();
      }
    },

    bjList(val) {
      if (val[0].police !== "0") {
        this.getInfoma();
        // this.getLwList()
      }
      setTimeout(() => {
        this.changPosition();
      }, 800);
    },

    showBD(val) {
      // log(this.editData)
      if (val) {
        setTimeout(() => {
          this.$post(
            "/demarcate/findbyc_number/" + this.BDform.c_company_num
          ).then((res) => {
            // log(res);
            // log(this.editData);
            this.editData = res.data.list || {};
            // log(this.editData);
          });
        }, 200);
      } else {
        this.editData = {};
        this.$refs.searchForm.reset();
      }
    },
  },
  created() {
    this.clearEchar();
  },
  mounted() {
    this.getAlarmOverview();
    this.getDeviceCountGroupType();
    this.getEstimate();
    this.getInspection();
    this.getelectricalInspection();
    this.getMaintenance();
  },

  methods: {
    close() {
      log("关闭Dialog");
      this.listParams.page = 1;
    },
    // 顶部服务类型
    // changeUnitTop() {},
    clearGetList() {
      this.leftFindParams = {
        areaList: [],
        cportList: [],
        supervisionLevel: "",
      };
      this.getLwList(true);
    },
    linkSearch(e) {
      if (this.topCompanyCount[e.key] == 0) {
        return;
      }
      console.log(e.value);
      this.leftFindParams.supervisionLevel = e.value;
      this.getLwList(true);
    },
    areaChange() {
      console.log(this.selectedArea);
      var arr = [];
      this.selectedArea.find((item) => {
        arr.push(item[0]);
      });
      this.leftFindParams.areaList = arr;
      this.getLwList(true);
    },
    changeTopService(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === Object.keys(this.$map.bjStatus).length;
      this.leftFindParams.cportList = this.selectServiceType;
      this.getLwList(true);
    },

    // 选择地区
    showPoint() {
      this.$router.push({
        path: "/report/report-list",
      });
    },
    stat() {
      // 更多设备
      this.showstatic = true;
    },
    gotoBD(it) {
      this.BDform = it;
      this.showBD = true;
    },
    uploadWT() {
      this.$post("jiejing/jjstart", this.upform).then((res) => {
        // this.$message.success("火警上报成功");
        this.$message({
          message: "火警上报成功",
          type: "success",
          duration: 700,
        });
        this.uploadmod = false;
      });
    },
    // crt点位
    openPoint(it) {
      var obj = { c_number: it.c_company_num, number: it.detailAddr || "" };
      this.$post("crt/crtselect", obj).then((res) => {
        if (!(res.data.length && res.data[0].area_uuid)) {
          // alert('无')
          this.$message.warning("该区域无点位标注，请联系管理员");
          return;
        }
        this.crtcompany = obj;
        this.crtpoint = true;
        // data[0]:报警的点位图及点位，闪动的点位
        //  data[1]:闪动的摄像头信息
        // data[2]:该点位图下绑定的其他点位位置
      });
    },

    sear() {
      this.unitbjList1 = [];
      if (!this.company) {
        return;
      }
      if (this.unitbjList.length) {
        this.unitbjList.map((item) => {
          if (item) {
            var searchStr = item.company || item.c_name;
            if (searchStr.indexOf(this.company) > -1) {
              this.unitbjList1.push(item);
            }
          }
        });
      }
    },

    getNowTime(type) {
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ")
        .replace(/-/g, "/");
      let timeLine = new Date(time).getTime();
      return new Date(timeLine).Format(type || "yyyy年MM月dd日 hh:mm:ss");
    },

    gettime(PAR) {
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ")
        .replace(/-/g, "/");
      let timeLine = new Date(time).getTime();
      PAR.starttime = new Date(timeLine).Format("yy年MM月dd日 00:00:00");
      PAR.endtime = new Date(timeLine).Format("yy年MM月dd日 23:59:59");
      this.getInfoList(PAR);
    },
    searchsub() {
      this.$refs.histsearch
        .getData()
        .then((data) => {
          
          this.listParams = { ...this.listParams, ...data };
          this.listParams.page = 1;
          // console.log(this.listParams);
          this.getHistAll(this.listParams);

          return;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.histsearch.reset();
      var params = { ...this.listParams, ...this.$refs.histsearch.models };
      params.page = 1;
      params.company = "";
      params.evenClass = "火警";

      this.getHistAll(params, true);

      this.histAll = true;
      this.listParams = params;

      this.listParams.c_company_num = "";
    },
    getMore(val) {
      if (val == true) {
        this.histAll = val;
      } else {
        this.histAll = false;
      }
      this.showMoreList = true;
    },

    // 收到报警该单位置顶
    changPosition() {
      if (this.bjList.length) {
        var c_numb = this.bjList[0].c_company_num;

        var eClass = this.bjList[0].evenClass;
        if (eClass === "火警" || eClass === "高温") {
          var change = false;
          for (var i = 0; i < this.unitbjList.length; i++) {
            if (this.unitbjList[i].c_company_num === c_numb) {
              console.log(this.unitbjList);
              change = true;
              var item = this.unitbjList[i];
              item.companycount ? item.companycount++ : item.count++;
              this.unitbjList.splice(i, 1);
              this.unitbjList.unshift(item);
              this.todayFireTotal++;
            }
          }
          if (!change) {
            this.getLwList(true);
          }
        }
      }
    },
    getDate() {
      var myDate = new Date(); //获取今天日期
      myDate.setDate(myDate.getDate() - 6);
      var dateArray = [];
      var dateTemp;
      var flag = 1;
      for (var i = 0; i < 7; i++) {
        dateTemp = myDate.getMonth() + 1 + "-" + myDate.getDate();
        dateArray.push(dateTemp);
        myDate.setDate(myDate.getDate() + flag);
      }
      this.dateArray = dateArray.reverse();
    },

    pageChange(val) {
      // console.log(val)
      this.listParams.page = val;
      if (this.histAll) {
        this.getHistAll(this.listParams, true);
      } else {
        this.getHistAll(this.listParams);
      }
    },
    //处理详情
    CLdatail(index, object) {
      this.CLIndex = index;
      var obj = object || this.companyInfo[index];
      for (var i in obj) {
        this.clForm[i] = obj[i];
      }
      this.clForm.type = obj.evenClass;
      this.clForm.context = this.clForm.context ? this.clForm.context : "";
      this.showCL = true;
    },

    //报警信息类
    getInfoma() {
      if (this.bjList.length) {
        var c_num = this.bjList[0].c_company_num;
        this.getUnit(c_num);
        this.getPointChart(c_num);
        if (!this.showMoreList) {
          this.listParams.c_company_num = c_num;

          this.getInfoList(this.listParams);
        }
      }
    },
    saveBD() {
      this.$refs.searchForm.getData().then((data) => {
        // log( this.unitbjList[this.companyInfoIndex].c_company_num)
        // log(data)
        var params = {
          ...data,
          c_number: this.BDform.c_company_num,
        };
        if (!params.starttime || !params.endtime || !params.type) {
          this.$message.warning("请填写正确时间信息");
          return;
        }
        this.showBD = false;

        if (params.type === "无") {
          this.$post("/demarcate/delebyc_number/" + params.c_number).then(
            (res) => {
              // this.$message.success("标定成功");
              this.$message({
                message: "标定成功",
                type: "success",
                duration: 700,
              });
              this.editData = {};
              this.BDform = {};
              this.getLwList();
              // this.getUnitNum();
              this.$refs.searchForm.reset();
            }
          );
        } else {
          // log(params)
          this.$post("/demarcate/savedemarcate", params).then((res) => {
            this.$message({
              message: "标定成功",
              type: "success",
              duration: 700,
            });
            // this.$message.success("标定成功");
            this.editData = {};
            this.$refs.searchForm.reset();
            this.getLwList();
            // this.getUnitNum();
          });
        }
      });
    },
    // 查看更多
    showMore(it) {
      this.listParams.c_company_num = it.c_company_num;
      this.listParams.company = "";
      this.getHistAll(this.listParams);
      this.showMoreList = true;
    },
    //一键处理
    handleByCom(id, it) {
      this.$confirm("确定一键处理该单位报警信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$post("/monitor/dealday", {
          c_number: id,
          dispose_time: this.getNowTime(null),
          dealName: this.$local.get("userInfo").nickName,
        }).then((res) => {
          console.log(res.date[0].countnotlist);
          this.$message("处理成功");

          this.getLwList(true);

          this.$store.commit("detailAll", res.date[0].countnotlist);
        });
      });
    },
    getHistory() {
      this.$post("/monitor/findonlytwentycount").then((res) => {
        this.todayBj = res;
      });
    },

    // 获取左上角 联网单位 报备单位分类即数量

    changeStatus(val) {
      this.evenClass = val;
      this.msgParams.evenClass = this.$map.leftStatus[val];
      this.listParams.type = this.$map.leftStatus[val];
      this.gettime({
        c_company_num: this.listParams.c_company_num,
        page: 1,
        limit: 10,
        type: this.$map.leftStatus[val],
      });
    },
    getHjMsg() {
      if (this.msgParams.page > this.msgParams.maxPage) {
        return;
      }
      this.msgLoading = true;
      getHjMsg(this.msgParams).then((res) => {
        this.MsgList.push(...res.countnotlist);
        this.msgParams.page += 1;
        this.msgParams.maxPage = Math.ceil(res.count / this.msgParams.limit);
        this.msgLoading = false;
      });
    },

    // 获取单位信息
    getInfo(c_number, index, name, a) {
      if (a) {
        this.$emit("local", c_number);
        this.listParams.page = 1;
      }
      this.rightLoading = true;
      this.companyInfoIndex = index;
      this.listParams.company = "";
      this.comnyInfo = name;
      this.getUnit(c_number);
      this.getPointChart(c_number);
    },

    //发起请求当前公司设备

    getDeviceState(c_number) {
      this.deviceload = true;

      this.$post("/demarcate/devicesshebei", { company_id: c_number }).then(
        (res) => {
          // return
          var {
            device,
            device_size,
            device_oldfive,
            device_oldfive_size,
            device_oldfour,
            device_oldfour_size,
            device_oldsix,
            device_oldsix_size,
            device_oldthree,
            device_oldthree_size,
            device_oldtwo,
            device_oldtwo_size,
            device_one,
            device_one_size,
          } = res.data;
          this.onlineList = [
            device_size,
            device_one_size,
            device_oldtwo_size,
            device_oldthree_size,
            device_oldfour_size,
            device_oldfive_size,
            device_oldsix_size,
          ];
          this.leaveList = [
            device ? device.length - device_size : 0,
            device_one ? device_one.length - device_one_size : 0,
            device_oldtwo ? device_oldtwo.length - device_oldtwo_size : 0,
            device_oldthree ? device_oldthree.length - device_oldthree_size : 0,
            device_oldfour ? device_oldfour.length - device_oldfour_size : 0,
            device_oldfive ? device_oldfive.length - device_oldfive_size : 0,
            device_oldsix ? device_oldsix.length - device_oldsix_size : 0,
          ];
          // this.makeline({ content: "device-count" });
        }
      );
    },
    getPointChart(company_num) {
      // this.rightPointLoading = true
      this.$post("/phpcontro/scorepicture", { company_id: company_num }).then(
        (res) => {
          if (res.data && res.data.length) {
            this.hasPoint = true;
            var arr = [];
            res.data.map((item) => {
              var obj = { name: item.label, value: Number(item.value) };
              arr.push(obj);
            });

            // setTimeout(() => {
            //   this.makecir(arr);
            // }, 20);
          } else {
            this.hasPoint = false;
          }
        }
      );
    },
    getUnit(c_number) {
      var firstLoading = false;
      var secondLoading = false;
      var thirdloading = false;
      this.$post("devicemanage/basesdetail", { c_company_num: c_number }).then(
        (res) => {
          this.unitInfo = res.data || {};
          firstLoading = true;
        }
      );
      this.$get("things/frontPage/companyInfo", { companyNum: c_number }).then(
        (res) => {
          console.log(res);
          this.companyInfomation = res.data;

          secondLoading = true;
        }
      );

      this.$get("/things/frontPage/moonCompanyAlarm", {
        companyNum: c_number,
      }).then((res) => {
        setTimeout(() => {
          this.thirdloading = true;
          if (firstLoading && secondLoading && thirdloading);
          this.rightLoading = false;
        }, 1000);
      });
    },

    load() {
      if (this.msgParams.page <= this.msgParams.maxPage && !this.msgLoading) {
        this.getHjMsg();
      }
    },
    loadList() {
      if (this.listParams.page <= this.listParams.maxPage && !this.msgLoading) {
      }
    },
    getHjList() {},
    getHistAll(obj) {
      this.moreLoad = true;

      this.$post("/monitor/selectalljilu", obj).then((res) => {
        // console.log(res);
        res.data?.map((item) => {
          // console.log(item, 'set item');
          if (item.nowtime && item.dispose_time) {
            item.isLate = this.changeTime(item.dispose_time, item.nowtime);
          } else {
            item.isLate = false;
          }
        });
        this.companyInfoCount = res.count;
        this.$set(this, "companyInfo", res.data);
        this.moreLoad = false;
      });
    },
    getInfoList(params, first, hist) {
      var today = false;
      var starttime = params.starttime.substring(
        0,
        params.starttime.indexOf(" ")
      );
      var nowtime = this.$local
        .get("nowtime")
        .substring(0, this.$local.get("nowtime").indexOf(" "));

      var endtime = params.endtime.substring(0, params.starttime.indexOf(" "));

      if (nowtime === starttime && nowtime === endtime) {
        today = true;
      }
      this.getHistAll(params);

      return;
    },

    changeTime(timeNow, timeBefore) {
      var _this = this;

      function changeStr(str) {
        // var str = _this.$local.get('nowtime')
        str = str.replace(/年/g, "/");
        str = str.replace(/月/g, "/");
        str = str.replace(/日/g, "");
        return str;
      }

      let timeLine = new Date(changeStr(timeNow)).getTime();
      let timeline = new Date(changeStr(timeBefore)).getTime();

      return (timeLine - timeline) / 1000 / 60;
    },

    handleById() {
      // console.log(this.clForm)
      let item = this.clForm;
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ")
        .replace(/-/g, "/");
      let timeLine = new Date(time).getTime();

      item.dispose_time = new Date(timeLine).Format("yyyy年MM月dd日 hh:mm:ss");
      item.dealName = this.$local.get("userInfo").nickName;
      item.isLate = this.changeTime(item.dispose_time, item.nowtime);

      // return
      if (item.dosomthing == 0) {
        this.leftfiretopLoading = true;
        handleById(item).then((res) => {
          // this.getUnitNum()
          this.getInfo(item.c_company_num, this.companyInfoIndex, item.company);
          this.listParams.page = 1;
          //
          //this.unitbjList[index].dosomthing = 1
          //this.$store.commit('saveBjList',this.unitbjList)
          this.$message("处理成功");
          this.leftfiretopLoading = false;
          // this.getLwList();
          this.getHistAll(this.listParams);
          // this.getUnitNum();

          // this.gettime(this.listParams);

          this.showCL = false;
          this.resetCl();
          this.$store.commit("editBjList", item);
        });
      }
    },
    resetCl() {
      this.clForm = {
        content: "",
        wubao: false,
      };
    },
    clearEchar() {
      this.clearFireProtectionHander();
      this.clearMaintenanceHander();
      this.clearInspectionHander();
      this.clearelectricalInspectionChartHander();
    },
    showMoreDias() {
      this.showMoreDia = this.showMoreListDia;
      this.showMoreDia = true;
    },
    // 获取报警概览数据
    getAlarmOverview() {
      alarmOverview({ companyNum: this.cpNum }).then((res) => {
        console.log(res,'alarmOverview');
        this.alarmOverviewList = res.data;
      });
    },
    // 获取各单位设备数量
    getDeviceCountGroupType() {
      deviceCountGroupType({ companyNum: this.cpNum }).then((res) => {
        console.log(res,'deviceCountGroupType');
        this.deviceCountGroupTypeList = res.data;
      });
    },
    // 消防图 li选择.....
    chooseType(item, index) {
      log(index);
      this.activeVar = index;
      switch (index) {
        case 0:
          this.getEstimate();
          this.clearMaintenanceHander();
          this.clearInspectionHander();
          this.clearelectricalInspectionChartHander();
          break;
        case 1:
          this.getMaintenance();
          this.clearFireProtectionHander();
          this.clearInspectionHander();
          this.clearelectricalInspectionChartHander();
          break;
        case 2:
          this.getInspection();
          this.clearFireProtectionHander();
          this.clearMaintenanceHander();
          this.clearelectricalInspectionChartHander();

          break;
        case 3:
          this.clearFireProtectionHander();
          this.clearMaintenanceHander();
          this.clearInspectionHander();
          break;
      }
    },
    // 获取评估
    getEstimate() {
      this.$post("/phpcontro/scorepicture", { company_id: this.cpNum }).then(
        (res) => {
          this.pieData = res.data;
          if (res.data) {
            this.disabled = false;
            this.pieData = this.pieData.map((item) => {
              return { name: item.label, value: item.value };
            });
            this.pieDataChart = this.$echarts.init(
              document.getElementById("FireProtectionChart")
            );
            // 饼图
            const option = {
              tooltip: {
                extraCssText: "z-index:9999999",
                tigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              textStyle: {
                fontSize: 10,
              },
              color: [
                "#4472c4",
                "#7a9bd5",
                "#ed7d31",
                "#f6c29d",
                "#70ad47",
                "#a9d18e",
              ],
              legend: {
                // 图例
                left: "1%",
                top: "20%",
                orient: "vertical",
              },
              title: [
                {
                  // 设置饼图标题，位置设为顶部居中
                  text: "单位消防评估汇总图",
                  top: "5%",
                  fontSize: 10,
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "normal",
                  },
                },
                {
                  triggerEvent: true, // 是否触发事件
                  fontSize: 30,
                  subtext: "查看详情",
                  top: "-1%",
                  width: "100",
                  left: "120",
                  subtextStyle: {
                    color: "rgba(120, 198, 240, 1)",
                    fontSize: 12,
                    textAlign: "center",
                    cener: "center",
                  },
                },
              ],
              series: [
                {
                  type: "pie",
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
                  },
                  radius: "70%", //饼图半径
                  data: this.pieData,
                  center: ["75%", "58%"],

                  itemStyle: {
                    normal: {
                      borderColor: "#FFFFFF",
                      borderWidth: 1,
                      label: {
                        show: false,
                        formatter: "{d}%",
                      },
                      labelLine: {
                        show: false,
                      },
                    },
                  },
                },
              ],
            };
            this.pieDataChart.setOption(option);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
              this.pieDataChart.resize();
            });
            this.pieDataChart.on("click", (params) => {
              this.$router.push({
                name: "/score/detail",
                path: "/home",
                query: {
                  c_num: this.cpNum,
                  name: this.$local.get("company").c_name,
                  type: 1,
                },
              });
            });
          }
        }
      );
    },
    // 获取维保
    getMaintenance() {
      var obj = {
        company_num: this.cpNum,
        endtime: "",
        page: 1,
        percentage_name: "",
        starttime: "",
        time: "",
        type: 2,
      };
      // this.$post("/score/scorelist", obj).then((res) => {
      //   this.Maintenance = res.data;
      //   this.MaintenanceData(this.Maintenance[0]);

      //   this.MaintenanceChart = this.$echarts.init(
      //     document.getElementById("MaintenanceChart")
      //   );
      //   if (res.data == []) {
      //     return this.clearMaintenanceHander();
      //   }
      // });
    },
    //   维保
    MaintenanceData(arr) {
      log(arr, 12312312);
      var namearr = [];
      var plusarr = [];
      var minusarr = [];
      // var timeArr = [];
      var lineArr = []; // 趋势折现
      var goodArr = [];
      if (arr?.date.length) {
        var valueArr = arr.date;
        // log(valueArr, 123);
        valueArr?.map((item) => {
          namearr.push(item.percentage_name);
          plusarr.push(
            Number(item.percentage_score) - Number(item.percentage_lose)
          ); // 未解决问题
          minusarr.push(Number(item.percentage_lose)); // 已解决问题
          goodArr.push(
            Number(item.percentage_score)
              ? 100 - Number(item.percentage_score)
              : 0
          );
          lineArr.push(
            Number(item.percentage_score)
              ? 100 -
                  Number(item.percentage_score) -
                  Number(item.percentage_lose) +
                  Number(item.percentage_lose)
              : 0
          );
        });
      } else {
        return false;
      }
      this.MaintenanceChart = this.$echarts.init(
        document.getElementById("MaintenanceChart")
      );

      const option_Maintenance = {
        tooltip: {
          extraCssText: "z-index:99999999999",
          trigger: "axis",
          show: true,
          axisPointer: {
            type: "cross",
            crossStyle: {
              // color: '#999',
            },
          },
          // formatter: function(params) {
          //   return `${namearr[params[0].dataIndex]}`;
          // },
        },
        grid: {
          top: 45,
          bottom: 28,
          left: 45,
          right: 5,
        },
        title: [
          {
            // 设置饼图标题，位置设为顶部居中
            left: 0,
            text: "单位消防维保汇总图",
            top: "5%",
            // left: "left",
            fontSize: 10,
            textStyle: {
              fontSize: 12,
              fontWeight: "normal",
            },
          },
          {
            triggerEvent: true, // 是否触发事件
            fontSize: 30,
            subtext: detail,
            top: "-1%",
            left: "120",
            subtextStyle: {
              color: "rgba(120, 198, 240, 1)",
              fontSize: 12,
              textAlign: "center",
            },
          },
        ],

        xAxis: [
          {
            type: "category",
            data: namearr,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,

            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        dataZoom: [
          {
            height: 20,
            // left: 0,
            bottom: "1.5%",
            handleStyle: {
              color: "#d3dee5",
            },
            textStyle: {
              color: "#000",
            },
            zoomLock: true,
          },
          {
            type: "inside",
            start: 0,
            end: 0,
          },
        ],
        // color: "#3f4048", //改变折线颜色
        series: [
          {
            name: "未解决趋势",
            type: "line",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              color: "#da6b6b",
            },
            data: plusarr,
          },
          {
            name: "已解决趋势",
            type: "line",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              color: "#b3eeca",
            },
            data: minusarr,
          },
        ],
      };
      this.MaintenanceChart.setOption(option_Maintenance);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.MaintenanceChart.resize();
      });
      this.MaintenanceChart.on("click", (params) => {
        this.$router.push({
          path: "/score/detail",
          query: { c_num: this.cpNum, name: this.companyName, type: 2 },
        });
      });
    },
    // // 获取消检
    getInspection() {
      var obj = {
        company_num: this.cpNum,
        endtime: "",
        page: 1,
        percentage_name: "",
        starttime: "",
        time: "",
        type: 5,
      };
      // this.interve()
      // this.$post("/score/scorelist", obj).then((res) => {
      //   if (res.data) {
      //     this.Inspection = res.data; // 所有月份维保数据
      //     // this.interve();
      //     this.InspectioData(this.Inspection[0]);
      //   }
      // });
    },
    //  消检
    InspectioData(arr) {
      // console.log(arr);
      let xAxis = [],
        barlist = [[], [], [], [], [], []],
        colorList = [
          "#597bf6",
          "#6be648",
          "#e6be30",
          "#839cf4",
          "#7fe8a9",
          "#f7d56e",
        ],
        lineColorList = ["#b3eeca", "#da6b6b", "#6584f6"],
        barTitleList = [
          "A项完好占比",
          "B项完好占比",
          "C项完好占比",
          "A项发现问题占比",
          "B项发现问题占比",
          "C项发现问题占比",
        ],
        lineTitleList = [
          "A项发现问题趋势",
          "B项发现问题趋势",
          "C项发现问题趋势",
        ],
        lineList = [];

      // 处理数据格式
      for (const key in arr?.date) {
        if (Object.hasOwnProperty.call(arr.date, key)) {
          // 初始化lineList数组
          xAxis.push(key);
          barTitleList.forEach((item, index) => {
            // barlist[index]
            typeof barlist[index] != "object" ? (barlist[index] = []) : "";
            // console.log(index % 2);
            index % 2
              ? barlist[index].push(
                  !arr.date[key].find((it) => {
                    return 2 * (it.uuid_kid.charCodeAt() - 65) + 1 == index;
                  })
                    ? 0
                    : Number(
                        arr.date[key].find((it) => {
                          return (
                            2 * (it.uuid_kid.charCodeAt() - 65) + 1 == index
                          );
                        }).percentage_score
                      )
                )
              : barlist[index].push(
                  !arr.date[key].find((it) => {
                    return 2 * (it.uuid_kid.charCodeAt() - 65) == index;
                  })
                    ? 0
                    : Number(
                        100 -
                          arr.date[key].find((it) => {
                            return 2 * (it.uuid_kid.charCodeAt() - 65) == index;
                          }).percentage_score
                      )
                );
          });
        }
      }
      [barlist[1], barlist[3]] = [barlist[3], barlist[1]];
      [barlist[1], barlist[2]] = [barlist[2], barlist[1]];
      [barlist[2], barlist[4]] = [barlist[4], barlist[2]];
      let barSeriesList = barlist.map((item, index) => {
        return {
          name: barTitleList[index],
          type: "bar",
          color: colorList[index],
          stack: String.fromCharCode((index % 3) + 65),
          label: {
            show: true,
          },
          emphasis: {
            focus: "series",
          },
          data: item,
        };
      });

      // console.log(barSeriesList, barlist);
      let lineSeriesList = [];
      if (barlist.length > 0)
        lineSeriesList = lineTitleList.map((item, index) => {
          return {
            name: item,
            type: "bar",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              color: lineColorList[index],
            },
            data: barlist[index + 3],
          };
        });
      // this.InspectionChart = this.$echarts.init(document.getElementById("InspectionChart"));
      const options_InspectionChart = {
        grid: {
          top: 30,
          left: 45,
          right: 5,
          bottom: 15,
        },
        title: [
          {
            // 设置饼图标题，位置设为顶部居中
            left: 0,
            text: "单位消防评消检总图",
            top: "3.5%",
            // left: "left",
            fontSize: 10,
            textStyle: {
              fontSize: 12,
              fontWeight: "normal",
            },
          },
          {
            triggerEvent: true, // 是否触发事件
            fontSize: 30,
            subtext: "查看详情",
            // height: "5",
            top: -3,
            left: "120",
            subtextStyle: {
              color: "rgba(120, 198, 240, 1)",
              fontSize: 12,
              textAlign: "center",
              cener: "center",
            },
          },
        ],
        tooltip: {
          confine: true,
          trigger: "axis",
          position: function(point, params, dom, rect, size) {
            return ["15%", 20];
          },
          className: "echarts-tooltip echarts-tooltip-dark",

          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisLabel: {
              formatter: function(value) {
                var str = value.split("");
              },
            },
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,

            axisLabel: {
              formatter: "{value}%",
            },
          },
        ],
        series: barSeriesList,
        showAllSymbol: true,
      };
      // this.InspectionChart.setOption(options_InspectionChart);
      // window.addEventListener("resize", () => {
      // 	this.InspectionChart.resize();
      // });
      // this.InspectionChart.on("click", (params) => {
      // 	// console.log(params);
      // 	this.$router.push({ name: "/score/detail", path: "'/score/detail'", query: { c_num: this.cpNum, name: this.companyName, type: 5 } });
      // });
    },

    // 获取电检
    getelectricalInspection() {},

    // 清除评估的梳实例
    clearFireProtectionHander() {
      this.$echarts
        .init(document.getElementById("FireProtectionChart"))
        .clear();
      // FireProtectionChart.clear();
    },
    // // 清除维保的实例
    clearMaintenanceHander() {
      this.$echarts.init(document.getElementById("MaintenanceChart")).clear();
    },
    // 清除消检的实例
    clearInspectionHander() {
      this.$echarts.init(document.getElementById("InspectionChart")).clear();
      // InspectionChart.clear();
    },
    // // 清除电检的实例
    clearelectricalInspectionChartHander() {
      this.$echarts
        .init(document.getElementById("electricalInspectionChart"))
        .clear();
      // electricalInspectionChart.clear();
    },
    addwater() {
      var water = document.getElementById("waterLevel");

      var video = document.getElementById("watchVideo");
      water.classList.add("visited");
      video.classList.remove("visited");
      this.$store.commit("getWaterModel");
    },
    addvideo() {
      var water = document.getElementById("waterLevel");
      var video = document.getElementById("watchVideo");

      video.classList.add("visited");
      water.classList.remove("visited");
      this.$store.commit("getVideoModel");
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 95%;
  z-index: 0;
  .overView {
    width: 100%;
    height: 100%;
    .data {
      width: 100%;
      height: 88%;
      display: grid;
      grid-auto-flow: column;
      gap: 0.3125rem;
      .dataList {
        display: grid;
        background: rgba(241, 241, 241, 1);
        grid-auto-flow: column;
        grid-template-columns: repeat(2, auto-fill);
        grid-template-rows: repeat(2, 1fr);
        align-items: center;
        justify-content: space-around;
        font-size: 0.875rem;
        font-weight: 400;
        letter-spacing: 0.0625rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: wrap;
        padding-left: 15px;
        .top {
          display: flex;
          justify-content: space-around;
          align-items: center;
          .bjList {
            padding-top: 0.3125rem;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
          }
          .img1 {
            width: 38.6896px;
            height: 38.6896px;
            border-radius: 0.125rem;
            background: rgba(255, 255, 255, 1);
            background-image: url("~@/assets/img/report/report-huojing.png");
            background-size: 60% 70%;
            background-repeat: no-repeat;
            background-position: center;
          }
          .img2 {
            width: 38.6896px;
            height: 38.6896px;
            border-radius: 0.125rem;
            background: rgba(255, 255, 255, 1);
            background-image: url("~@/assets/img/report/report-jiankong.png");
            background-size: 65% 75%;
            background-repeat: no-repeat;
            background-position: center;
          }
          .img3 {
            width: 2.4181rem;
            height: 2.4181rem;
            border-radius: 0.125rem;
            background: rgba(255, 255, 255, 1);
            background-image: url("~@/assets/img/report/report-xuncha.png");
            background-size: 70% 70%;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
        .botoom {
          font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
          font-size: 20px;
          letter-spacing: 0.25rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          text-align: center;
          width: 4.375rem;
          cursor: pointer;
        }
      }
      .dataList1:nth-child(1) {
        // position: relative;
        // padding: .3125rem;
        background: rgba(241, 241, 241, 1);
        // width: 400px;
        display: flex;
        justify-content: space-around;
        .contents {
			height: 200px;
          display: grid;
          align-items: center;
          gap: 0.6rem;
        }
        .fireArem {
          position: relative;
          top: 0.5rem;
          width: 50%;
          height: 90%;
          // margin-top: .5rem;
          // margin-top: .3125rem;
          background-color: #ffffff;
          display: flex;
          flex-direction: column;
          // justify-content: space-around;
          align-items: center;
          .img1 {
            width: 5.625rem;
            height: 5.625rem;
            background: rgba(255, 255, 255, 1);
            background: url("~@/assets/img/report/reportList.png") no-repeat
              center;
            object-fit: cover;
            background-size: 70% 80%;
          }
        }
        .botoom {
          font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
          font-size: 20px;
          letter-spacing: 0.25rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          text-align: center;
          width: 4.375rem;
          cursor: pointer;
          text-align: end;
        }
      }
      .dataList1:nth-child(2) {
        background: rgba(241, 241, 241, 1);
        // width: 14.375rem;
        display: grid;
        background: rgba(241, 241, 241, 1);
        grid-auto-flow: column;
        grid-template-columns: repeat(2, auto-fill);
        grid-template-rows: repeat(2, 1fr);
        align-items: center;
        justify-content: space-around;
        font-size: 0.875rem;
        font-weight: 400;
        letter-spacing: 0.0625rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .img2 {
          width: 38.6896px;
          height: 38.6896px;
          border-radius: 0.125rem;
          background: rgba(255, 255, 255, 1);
          background-image: url("~@/assets/img/report/report-jiankong.png");
          background-size: 65% 75%;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
      .dataList1:nth-child(3) {
        // width: 14.375rem;
        display: grid;
        background: rgba(241, 241, 241, 1);
        grid-auto-flow: column;
        grid-template-columns: repeat(2, auto-fill);
        grid-template-rows: repeat(2, 1fr);
        align-items: center;
        justify-content: space-around;
        font-size: 0.875rem;
        font-weight: 400;
        letter-spacing: 0.0625rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .img3 {
          width: 2.4181rem;
          height: 2.4181rem;
          border-radius: 0.125rem;
          background: rgba(255, 255, 255, 1);
          background-image: url("~@/assets/img/report/report-xuncha.png");
          background-size: 70% 70%;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
    .dataChartList {
      z-index: 0 !important;
      margin-top: 0.3125rem;
      width: 100%;
      height: 55%;
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: 1.5fr 1fr;
      gap: 5px;

      .chart {
        min-width: 100%;
        border: 0.0625rem solid #2196f3;
        position: relative;
        .noneFont {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .chartBtn {
          width: 100%;
          overflow: hidden;
          height: 1.25rem;
          display: flex;
          justify-content: flex-end;

          .CRTbtn {
            // cursor: pointer;
            border: 0.0625rem solid #4ba0e5;
            margin: 0;
            border-radius: 0.1875rem;
            width: 3.4375rem;
            color: gray;
            border-top: none;
            text-align: center;
            line-height: 0.125rem;
            z-index: 99999;
          }
        }
        .FireProtectionChart {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -9999;
        }
        .MaintenanceChart {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -9999;
        }
        .InspectionChart {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -9999;
        }
      }
      .device {
        -ms-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        // height: ;
        width: 100%;
        border: 0.0625rem solid #2196f3;
        .title {
          min-width: 12.5rem;
          height: 10%;
          font-size: 0.875rem;
        }
        .deviceList {
          width: 100%;
          margin-top: 1.25rem;
          height: 75%;
          // width: 100%;
          // grid-auto-flow: column;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(3, 1fr);
          > div {
            // width: 100%;
            display: flex;
            justify-content: space-around;
            > p:nth-child(1) {
              max-height: 2.1875rem;
              max-width: 4.6875rem;
              font-size: 0.875rem;
              font-weight: 400;
              letter-spacing: 0.0256rem;
              color: rgba(42, 43, 49, 1);
              text-align: center;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              line-height: 3;
            }
            > p:nth-child(2) {
              margin-left: 0.3125rem;
              margin-top: 0.5rem;
              width: 1.5625rem;
              height: 1.25rem;
              border-radius: 0.125rem;
              background: rgba(241, 241, 241, 1);
              font-size: 0.875rem;
              font-weight: 400;
              letter-spacing: 0.0187rem;
              color: rgba(42, 43, 49, 1);
              text-align: center;
              line-height: 1.25rem;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
.elButton {
  width: 3.5rem;
  height: 1.25rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: rgba(120, 198, 240, 1);
  font-weight: 10;
  font-size: 0.625rem;
  border: 0.0625rem solid rgba(120, 198, 240, 1);
}

.visited {
  border-bottom: 0.0625rem solid #2196f3;
  color: #2196f3;
}
.firewaring {
  animation: warningmove 0.3s infinite;
  animation-direction: alternate;
  opacity: 0.5;
  background-image: url("~@/assets/img/report/report-huojing.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 99;
}

@keyframes warningmove {
  from {
    background: #ed1c24;
    background-size: 60% 70%;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 1;
  }
  to {
    background: #ffb800;
    background-size: 60% 70%;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 1;
  }
}

.fire-botton {
  // padding: .3125rem;
  width: 5rem;
  height: 1.25rem;
  margin-top: 0.3125rem;
  border-radius: 0.625rem;
  box-shadow: none;
  color: red;
  font-weight: 900;
  cursor: pointer;
  border: 0.0625rem solid #2195f34a;
  font-size: 0.875rem;
  background: #fff;
}
.botoom {
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  font-size: 20px;
  letter-spacing: 0.25rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  width: 100%;
  cursor: pointer;
}

#overall-rating {
  height: 12vw;
}
#alarm-count-chart {
  height: 80%;
  margin: 20px;
  width: 100%;
}
.mark > td {
  color: red;
  font-weight: 500;
  // background: rgba(255,0,0,.4);
}

.hj-message-table {
  width: 100%;
  margin-top: 5px;

  thead {
    tr {
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 0px;
      color: rgba(62, 182, 238, 1) !important;
      text-align: left;
      vertical-align: top;
    }
  }
  td {
    line-height: 30px;
    font-weight: 400;
  }
  .active {
    background: #4a9dff !important;
    td,
    [class^="icon-"]:before {
      color: #fff !important;
    }
  }
}

.red {
  font-weight: 900;
}
table {
  line-height: 1.8;
}

.main_navigation_shu_bar_hj {
  display: none;
}

.last-btn {
  margin-left: 92px;
}
.form-item {
  width: 100%;
}
.el-form-last {
  display: flex;
}
.last-form {
  display: flex;
  align-items: center;
  margin-bottom: 28px;
}

.crtVideoDia {
  z-index: 99 !important;
}
.cl {
  z-index: 99999;
}
.huanhang {
}
</style>
